<template>
  <el-dialog :title="title" :visible.sync="detailMark" :close-on-click-modal="false" width="90%" center
    :before-close="closeadd">
    <div class="dialog-table-wrapper">
      <div style="display: flex;margin-bottom: 8px;padding-left: 5px;">
        <div style="width: 40px;height: 20px; background-color:#F56C6C; border-radius: 5px; margin-right: 3px;"></div><div>当前数据被调整</div>
      </div>
      <el-form :inline="true"  class="demo-form-inline" label-width="80px" size="mini" style="width: 100%;">
         <el-form-item >
           <p class="margin0">计划收入合计:<span class="red">{{mapData.predictedIncome}}</span>万元</p>
          </el-form-item>
           <el-form-item >
           <p class="margin0">计划支出合计:<span class="red">{{mapData.predictedExpense}}</span>万元</p>
          </el-form-item>
           <el-form-item >
           <p class="margin0">实际收入合计:<span class="red">{{mapData.actualIncome}}</span>万元</p>
          </el-form-item>
           <el-form-item >
           <p class="margin0">实际支出合计:<span class="red">{{mapData.actualExpense}}</span>万元</p>
          </el-form-item>
      </el-form>
      <el-table :data="tableDataList" ref="table" bordersize="mini" style="width: 100%" class="tableComent" highlight-current-row center border
      :height="tableHeight" :key="tableKey" :row-style="setRowStyle">
        <el-table-column prop="incomeExpenseType" min-width="75" label="调整记录" fixed="">
          <template slot-scope="scope">
              <el-button type="text" size="mini" v-if="scope.row.adjustFlag==1" @click="tiaozhengjiluFN(scope.row)">调整记录</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="incomeExpenseType" min-width="75" label="收支类型" fixed="">
          <template slot-scope="scope">
              <span>{{ scope.row.incomeExpenseType == 0 ? '收款' : '付款' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="flowItemName" min-width="130" label="现金流项目"></el-table-column>
        <el-table-column prop="itemName" width="90" label="项目名称"></el-table-column>
        <!-- <el-table-column prop="paymentCycle" width="90" label="收付款周期"></el-table-column> -->

        <el-table-column prop="debtAmount" width="98" label="总欠款(万元)"></el-table-column>
        <el-table-column prop="supplierName" width="130" label="供应商"></el-table-column>
         <el-table-column prop="incomeExpenseType" width="90" label="收支方式">
          <template slot-scope="scope">
              <span>{{['现金' ,'承兑','现汇'][scope.row.paymentMethods]}}</span>
          </template>
        </el-table-column>

        <template v-for="item in tableHeadList">
          <el-table-column :key="item.id" :label="item.name" width="100">
            <template slot-scope="scope">
              <div>
                <span v-if="!scope.row.isEditing">{{ scope.row.cycleAmounts[item.valueKey] }}</span>
                <el-input v-else v-model="scope.row.cycleAmounts[item.valueKey]" @input="handleCycleAmount(scope.row, item, $event)" v-number-input.float="4" placeholder="请输入" size="mini"></el-input>
              </div>
            </template>
          </el-table-column>
        </template>
        <el-table-column prop="incomeExpenseType" width="90" label="开票情况">
          <template slot-scope="scope">
              <span>{{ ['已开票' ,'款到发货','预付款'][scope.row.invoiceStatus] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="predictedAmount" width="140" label="预估收支合计(万元)"></el-table-column>
        <el-table-column prop="actualAmount" width="110" label="实际收支(万元)"></el-table-column>

        <el-table-column prop="remark" width="100" label="备注"></el-table-column>

      </el-table>
    </div>
    <div slot="footer">
      <el-button @click="closeadd">取 消</el-button>
    </div>
     <tiaozhengjilu v-if="jiluMark" :jiluMark.sync="jiluMark" :rowData="currentEditingRow"  ></tiaozhengjilu>
  </el-dialog>
</template>

<script>
import { weekDetailList } from '@/api/common-signature'
import tiaozhengjilu from '@/views/common-signature/fundingPlan/public/tiaozhengjilu.vue'
export default {
  name: 'monthPlanDialog',
  components: { tiaozhengjilu },
  data () {
    return {
      tableDataList: [],
      rules: {},
      orgTreeData: [],
      BMlist: [],
      searchForm: {
        pageNo: 1,
        pageSize: 50,
        yearMonthDate: ''
      },
      tableHeadList: [],
      detailForm: {
        pageNo: 1,
        pageSize: 200,
        incomeExpenseType: ''
      },
      tableHeight: 500,
      tableKey: 0,
      currentEditingRow: null, // 当前正在编辑的行
      isAnyRowEditing: false, // 是否有行正在编辑
      jiluMark: false,
      mapData: {}
    }
  },
  props: {
    title: {
      type: String
    },
    detailMark: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.adjustTableHeight()
    })
  },
  created () {
    this.detailList()
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.$refs.table) {
          this.$refs.table.doLayout()
        }
      }, 200)
    })
  },
  watch: {
    tableHeadList: {
      handler (newVal) {
        if (newVal && newVal.length > 0 && this.tableDataList.length > 0) {
        // 当表头变化时，确保每行数据都有对应的动态列值
          this.tableDataList.forEach(row => {
            if (!row.cycleAmounts) {
              row.cycleAmounts = {}
            }
            newVal.forEach(header => {
              if (row.cycleAmounts[header.valueKey] === undefined) {
                this.$set(row.cycleAmounts, header.valueKey, '')
              }
            })
          })
        }
        this.$nextTick(() => {
          this.adjustTableHeight()
        })
        this.$nextTick(() => {
          this.tableKey += 1
        })
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    tiaozhengjiluFN (row) {
      this.jiluMark = true
      this.currentEditingRow = row
    },
    setRowStyle ({ row, index }) {
      if (row.adjustFlag === '1') {
        return {
          background: '#F56C6C' // 浅红色背景（可自定义）
        }
      }
      return {}
    },
    adjustTableHeight () {
      // 基础高度
      let baseHeight = 600

      // 根据数据量调整
      const rowCount = this.tableDataList.length
      if (rowCount > 10) {
        baseHeight = 600
      }

      this.tableHeight = baseHeight
    },
    detailList () {
      this.$set(this.detailForm, 'weeklyPlanMasterId', this.rowData.id)
      this.$set(this.detailForm, 'incomeExpenseType', this.rowData.incomeExpenseType)
      weekDetailList(this.detailForm)
        .then(res => {
          console.log(res)
          this.mapData = res.tWeeklyFundPlanMaster
          this.tableHeadList = res.titleList || []
          if (res.pageInfo && res.pageInfo.list && res.pageInfo.list.length > 0) {
            // 处理数据，确保动态列的值正确绑定
            this.tableDataList = res.pageInfo.list.map(item => {
              // 确保 cycleAmounts 存在
              if (!item.cycleAmounts) {
                item.cycleAmounts = {}
              }

              // 将动态表头对应的值赋值给 cycleAmounts
              if (this.tableHeadList && this.tableHeadList.length > 0) {
                this.tableHeadList.forEach(header => {
                  // 如果返回的数据中有动态列的值，将其放入 cycleAmounts
                  if (item[header.valueKey] !== undefined) {
                    item.cycleAmounts[header.valueKey] = item[header.valueKey]
                  } else if (item.cycleAmounts[header.valueKey] === undefined) {
                    // 如果没有值，设置为空字符串
                    item.cycleAmounts[header.valueKey] = ''
                  }
                })
              }
              return item
            })
          }
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            onClose () {
            }
          })
        })
    },
    closeadd () {
      this.currentEditingRow = null
      this.isAnyRowEditing = false
      this.$emit('update:detailMark', false)
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-table th.star div::before {
  content: '*' !important;
  color: red !important;
}
.dialog-table-wrapper {
  // 确保容器不会限制表格
  min-height: 300px;
  max-height: 700px;
  overflow: hidden;
}

// 确保表格滚动正常工作
::v-deep .el-table__body-wrapper {
  overflow-y: auto !important;
}
</style>
